import { RouterView } from "vue-router";
import { META_ALLOW_ANONYMOUS, META_LAYOUT, META_FORCE_ANONYMOUS, META_HTML_TITLE } from "@core/constants";
import { ETAB_LAYOUTS, ETAB_ROUTES } from "@etab/config";
import { StorageManager } from "@core/managers/storage.manager";
import { DataLayerManager } from "@core/managers/datalayer-manager";
import LandingPage from "./Landing.page.vue";
import WrongAppPage from "./WrongApp.page.vue";
import LoginPage from "./Login.page.vue";
import SignupPage from "./Signup.page.vue";
import UpdatePage from "./Update.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.auth.root.path,
      name: ETAB_ROUTES.auth.root.name,
      component: RouterView,
      redirect: { name: ETAB_ROUTES.auth.landing.name },
      // startup pages are only for non auth users
      meta: { [META_FORCE_ANONYMOUS]: true, [META_LAYOUT]: ETAB_LAYOUTS.startup },
      children: [
        {
          path: ETAB_ROUTES.auth.landing.path,
          name: ETAB_ROUTES.auth.landing.name,
          component: LandingPage,
          meta: { [META_FORCE_ANONYMOUS]: true },
          async beforeEnter(to, from, next) {
            DataLayerManager.setData({ page_type: "home", user_connect: "no" }, "etablissement", StorageManager.getUserInfo("etablissement"));
            next();
          },
        },
        {
          path: ETAB_ROUTES.auth.login.path,
          name: ETAB_ROUTES.auth.login.name,
          component: LoginPage,
          meta: { [META_FORCE_ANONYMOUS]: true, [META_HTML_TITLE]: "ETAB.PAGES.LOGIN.META.@TITLE" },
          async beforeEnter(to, from, next) {
            DataLayerManager.setData({ page_type: "login", user_connect: "no" }, "etablissement", StorageManager.getUserInfo("etablissement"));
            next();
          },
        },
        {
          path: ETAB_ROUTES.auth.signup.path,
          name: ETAB_ROUTES.auth.signup.name,
          component: SignupPage,
          meta: { [META_FORCE_ANONYMOUS]: true, [META_HTML_TITLE]: "ETAB.PAGES.SIGNUP.META.@TITLE" },
          async beforeEnter(to, from, next) {
            DataLayerManager.setData(
              { page_type: "formulaire", user_connect: "no", formulaire: "creation_annonce" },
              "etablissement",
              StorageManager.getUserInfo("etablissement"),
            );
            next();
          },
        },
        {
          path: ETAB_ROUTES.auth.wrongApp.path,
          name: ETAB_ROUTES.auth.wrongApp.name,
          component: WrongAppPage,
          meta: { [META_FORCE_ANONYMOUS]: true },
        },
      ],
    },
    {
      path: ETAB_ROUTES.update.path,
      name: ETAB_ROUTES.update.name,
      component: UpdatePage,
      meta: { [META_ALLOW_ANONYMOUS]: true, [META_LAYOUT]: ETAB_LAYOUTS.startup },
    },
  ];
}
